import { ArrowRight, Download, ExternalLink, Sparkles } from "lucide-react";
import type { ActionButton, ActionButtonKind } from "./types";

// Click-to-confirm chip rendered below an assistant message.
// 4 kinds: navigate / apply_to_current_view / open_record / export.
// The chip is thin — onClick fires with the action; AssistantPanel owns
// the actual handler (command dispatch, applyOps, export trigger).

const ICON_FOR: Record<ActionButtonKind, typeof ArrowRight> = {
    navigate: ArrowRight,
    apply_to_current_view: Sparkles,
    open_record: ExternalLink,
    export: Download,
    // propose_custom_field renders as a CustomFieldConfirmCard (see
    // AssistantMessageLine), never as this thin chip — entry is for type
    // completeness only.
    propose_custom_field: Sparkles,
};

const TITLE_FOR: Record<ActionButtonKind, string> = {
    navigate: "Navigate to the suggested screen",
    apply_to_current_view: "Apply this change to the current view",
    open_record: "Open this record",
    export: "Export the current selection",
    propose_custom_field: "Review the proposed custom field",
};

interface Props {
    action: ActionButton;
    onClick: (action: ActionButton) => void;
    disabled?: boolean;
}

export function AssistantActionButton({ action, onClick, disabled }: Props) {
    const Icon = ICON_FOR[action.kind] ?? ArrowRight;
    return (
        <button
            type="button"
            className="assistant-action-chip"
            data-kind={action.kind}
            data-testid={`assistant-action-${action.kind}`}
            onClick={() => onClick(action)}
            disabled={disabled}
            title={TITLE_FOR[action.kind] ?? ""}
        >
            <Icon size={12} />
            <span>{action.label}</span>
        </button>
    );
}
